import type { ApiContactPhone } from '@/api/conversations/types/index.ts';
import Model from '@/entities/Model.js';

export default class ConversationContactPhone extends Model {
    declare id: number;

    declare phone: string;

    declare type: string | null;

    static get defaults() {
        return {
            id: 0,
            phone: '',
            type: null,
        };
    }

    static fromApi(contactPhone: ApiContactPhone): ConversationContactPhone {
        return new ConversationContactPhone({
            id: contactPhone.id,
            phone: contactPhone.phone,
            type: contactPhone.type,
        });
    }

    constructor(initialValues: Partial<ConversationContactPhone> = {}) {
        super(initialValues);
    }
}
